import {Extension} from '@tiptap/core'
import {Plugin, PluginKey} from 'prosemirror-state'
import {Decoration, DecorationSet} from 'prosemirror-view'

const selectionHighlightKey = new PluginKey('selectionHighlight')

const SelectionHighlight = Extension.create({
  name: 'selectionHighlight',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: selectionHighlightKey,
        state: {
          init() {
            return DecorationSet.empty
          },
          apply(tr, old, _oldState, newState) {
            const meta = tr.getMeta(selectionHighlightKey)
            if (meta === 'blur') {
              const {from, to} = newState.selection
              if (from !== to) {
                const decoration = Decoration.inline(from, to, {
                  class: 'html-editor-selection-highlight',
                })
                return DecorationSet.create(newState.doc, [decoration])
              }
              return DecorationSet.empty
            }
            if (meta === 'focus') {
              return DecorationSet.empty
            }
            return old.map(tr.mapping, tr.doc)
          },
        },
        props: {
          decorations(state) {
            return selectionHighlightKey.getState(state)
          },
          handleDOMEvents: {
            blur(view) {
              view.dispatch(
                view.state.tr.setMeta(selectionHighlightKey, 'blur'),
              )
              return false
            },
            focus(view) {
              view.dispatch(
                view.state.tr.setMeta(selectionHighlightKey, 'focus'),
              )
              return false
            },
          },
        },
      }),
    ]
  },
})

export default SelectionHighlight
